import styled from "styled-components";

const Align = styled.div`
  display: flex;
`;

export default Align;
